import CmsFeaturesSellersApiV2 from 'api/v2/admins/cms-features-sellers-api-v2'
import { SelectSearchField } from 'components'
import React, { useState } from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true
}

/**
 * Search field to select customer by customer code.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 */
const CmsFeaturedSellerSelectSearchField = ({
  name,
  label,
  required,
  ...props
}) => {
  const [ searchFeaturedSellers, setSearchFeaturedSellers ] = useState([])
  const [ isSearchLoading, setSearchLoading ]               = useState(false)

  var featuredSellerSearchTimeout = null

  // search featured seller by name
  const getFeaturedSellers = (fsName) => {
    setSearchLoading(true)
    CmsFeaturesSellersApiV2.filterByName( fsName )
      .then((response) => {
        setSearchFeaturedSellers(response.data.featured_sellers)
      })
      .catch(() => alert('Something wrong when showing featured sellers'))
      .finally(() => setSearchLoading(false))
  }

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option?.seller?.name }</span>
      <span className='mr-3'>{ '-' }</span>
      <span className='mr-3'>{ option?.seller?.username }</span>
    </>
  )

  // use to get the Formik field values
  const getOptionValue = (option) => option.id

  // handler to search customers
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    if (featuredSellerSearchTimeout) clearTimeout(featuredSellerSearchTimeout)
    featuredSellerSearchTimeout = setTimeout(() => {
      getFeaturedSellers(searchText)
    }, 700)
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder='Search with featured seller name'
      dataList={ searchFeaturedSellers }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ getOptionLabel }
      getOptionValue={ getOptionValue }
      isLoading={ isSearchLoading }
      required={ required }
      onSelect={ () => {} }
      { ...props }
    />
  )
}

CmsFeaturedSellerSelectSearchField.propTypes    = propTypes
CmsFeaturedSellerSelectSearchField.defaultProps = defaultProps

export default CmsFeaturedSellerSelectSearchField
